import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import InputDateTime from '../input/DateTime';
import FormFieldBase from './FieldBase';
/**@param {import('./types').FinalFormFieldDateTimeProps} props */

var DateTimeFormField = function DateTimeFormField(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      type = _ref$input.type,
      onFocus = _ref$input.onFocus,
      onBlur = _ref$input.onBlur,
      restInput = _objectWithoutProperties(_ref$input, ["name", "onChange", "value", "type", "onFocus", "onBlur"]),
      meta = _ref.meta,
      rest = _objectWithoutProperties(_ref, ["input", "meta"]);

  return React.createElement(InputDateTime, Object.assign({}, rest, {
    name: name,
    helperText: meta.touched ? meta.error : undefined,
    error: meta.error && meta.touched,
    inputProps: restInput,
    onChange: onChange,
    value: value,
    type: type,
    onFocus: onFocus,
    onBlur: onBlur
  }));
};

export var DateTime = function DateTime(_ref2) {
  var name = _ref2.name,
      rest = _objectWithoutProperties(_ref2, ["name"]);

  var validationProps = useMuiPickerFinalFormValidation(rest);
  return React.createElement(FormFieldBase, Object.assign({
    name: name,
    label: name
  }, rest, validationProps, {
    allowNull: true
  }));
};

var useMuiPickerFinalFormValidation = function useMuiPickerFinalFormValidation(props) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      internalError = _React$useState2[0],
      setError = _React$useState2[1];

  var validationProps = {
    //final form
    validate: function validate(value) {
      var error = props.validate ? props.validate(value) : null;
      return error || internalError;
    },
    //mui picker
    onError: function onError(errorMessage, inputValue) {
      if (props.onError) props.onError(errorMessage, inputValue);
      setError(errorMessage || undefined);
    },
    onAccept: function onAccept() {
      if (props.onAccept) props.onAccept.apply(props, arguments);
      setError(undefined);
    }
  };
  return validationProps;
};

DateTime.defaultProps = {
  component: DateTimeFormField,
  onChange: function onChange(f) {
    return f;
  },
  margin: 'normal',
  fullWidth: true
};
export default DateTimeFormField;